import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './pages/Login/Login';
import Registration from './pages/Registration/Registration/registration';
import Changedisplayname from './pages/Home/ChangeDisplayName/changedisplayname';
import Resetpassword from './pages/Home/ResetPassword/ResetPassword';
import ChangePassword from './pages/Home/ChangePassword/ChangePassword';
import AddService from './pages/RoleServiceMap/AddService/AddService';
import Createrole from './pages/RoleServiceMap/CreateRole/CreateRole';
import Roleservicemap from './pages/RoleServiceMap/RoleServiceMap/RoleServiceMap';
import Userservicemap from './pages/Testing/Userservicemap';
import PersonalDetails from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeesRegistrationNavbar/PersonalDetaills/PersonalDetails';
import EducationDetails from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeesRegistrationNavbar/EducationDetails/EducationDetails';
import Addressdetails from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeesRegistrationNavbar/AddressDetails/Addressdetails';
import Home from './components/layout/Home/Home';
import ExperienceDetails from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeesRegistrationNavbar/ExperienceDetails/Experiencedetails';
import Bankdetails from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeesRegistrationNavbar/BankDetails/Bankdetails';
import Dashboard from './pages/Home/Dashboards/Dashboard/Dashboard';
import Attendence from './pages/DailyAttendace/DailyAttendanceForm/Attendence';
import HolidayManagement from './pages/HolidayManagementAndLeaves/HolidayManagement/HolidayManagement';
import SalaryStructure from './pages/SalaryStructure/SalaryStructureForm/SalaryStructure';
import RegistrationNavbar from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeesRegistrationNavbar/EmployeeRegistartion/RegistrationNavbar';
import EmployeeOnboarding from './pages/EmpolyeesOnboarding/EmployeeOnboardingToday/EmployeeOnboarding';
import LeaveRequest from './pages/HolidayManagementAndLeaves/LeaveRequest/LeaveRequest';
import AdminLeaveTable from './pages/HolidayManagementAndLeaves/AdminLeaveTable/AdminLeaveTable';
import EmployeesRegistered from './pages/Registration/RegistredEmployeeList/RegisteredEmployees';
import EmployeesAttendance from './pages/DailyAttendace/EmployeeDailyAttendanceReport/EmployeesAttendanceReport';
import PFdetails from './pages/SalaryStructure/PfDetails/PFdetails';
import RegistedEmployees from './pages/Detiails/ProfilesForInterview/EmployeeDetails/RegistedEmployees';
import SalaryReport from './pages/SalaryStructure/SalaryReport/SalaryReport';
import RequirementManPowerForInterview from './pages/Interviews/RequestManPower/RequestForManPower/RequirementManPowerForInterview';
import PortalOrAgencyForInterview from './pages/Interviews/RequestManPower/JobPulicationPortalOrAgency/PortalOrAgencyForInterview';
import ShortListedByshortlistTeam from './pages/Interviews/ShortListRound/ShortListByHR/ShortListedByHrTeam';
import InterviewForInterview from './pages/Interviews/ShortListRound/ScheduleInterview/InterviewForInterview';
import Feedbackform from './pages/Interviews/InterviewFeedback/Feedbackform';
import HrRoundForInterview from './pages/Interviews/HRInterview/HrRoundForInterview';
import ProfilesForInterview from './pages/Detiails/ProfilesForInterview/ProfileForInterview/ProfilesForInterview';
import DetailsofAddress from './pages/Detiails/ProfilesForInterview/AddressDetails/DetailsofAddress';
import Testing from './pages/Testing/Testing';
import ReportsOfInterview from './pages/Interviews/ReportsOfInterview/ReportsOfInterview';
import Profile from './pages/Home/Profile/Profile';
import Resignform from './pages/Resignation/ResignForm/Resignform';
import Profileinfo from './pages/Detiails/ProfilesInfo/Profileinfo';
import ListofResign from './pages/Resignation/ListOfResignations/ListofResign';
import IDDetails from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeesRegistrationNavbar/IdDetails/IDDetails';
import EmployeeCreationForm from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeeCreationForm/EmployeeCreationForm';
import EmployeeApplications from './pages/EmployeesProfile/EmployeeApplication/EmployeeApplications';
import DraftApplications from './pages/EmployeesProfile/PendingProfiles/DraftEmployess/DraftApplications';
import SubmittedApplications from './pages/EmployeesProfile/CompletedProfiles/SubmittedApplications';
import PreviewPage from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeesRegistrationNavbar/EmployeePreview/PreviewPage';
import CheckList from './pages/Verifications/HRVerfication/CheckList';
import ManagerCheckList from './pages/Verifications/ManagerVerification/ManagerVerticationEmployeesList/ManagerCheckList';
import ManagerCheckListView from './pages/Verifications/ManagerVerification/ManagerVerficationViewEmployee/ManagerCheckListView';
import ManagerCheckListReject from './pages/Verifications/ManagerVerification/ManagerVerificationRejetionList/ManagerCheckListReject';
import Certifications from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeesRegistrationNavbar/OtherCertificates/Certifications';
import OnboardingEmployeesList from './pages/EmpolyeesOnboarding/OnBoardingEmployeeList/OnboardingEmployeesList';
import OnboardingDetails from './pages/EmpolyeesOnboarding/OnBoardingEmployeeDetails/OnboardingEmployeeDetails';
import OnboardingEmployeeDetails from './pages/EmpolyeesOnboarding/OnBoardingEmployeeDetails/OnboardingEmployeeDetails';
import ESICForm from './pages/SalaryStructure/ESI/ESICForm';
import ApprovedApplications from './pages/EmployeesProfile/ResubmitProfiles/ResubmitApplications';
import EPFForm from './pages/SalaryStructure/EPF/EPFForm';
import OnboardingPending from './pages/EmpolyeesOnboarding/EmployeeOnboardingPending/OnboardingPending';
import EmployeeJoiningForm from './pages/EmployeeJoiningForm/EmployeeJoiningForm';
import EmployeePosting from './pages/EmployeePostingAndTransfer/EmployeePosting/EmployeePosting';
import EmployeeTransfer from './pages/EmployeePostingAndTransfer/EmployeeTransfer/EmployeeTransfer';
import MonthlyAttendance from './pages/MonthlyAttendance/MonthlyAttendanceForm/MonthlyAttendance';
import MonthlyAttendanceReport from './pages/MonthlyAttendance/MonthlyAttendanceReport/MonthlyAttendanceReport';
import MonthlyAttendanceVerification from './pages/MonthlyAttendance/MonthlyAttendanceVerification/MonthlyAttendanceVerification';
import MonthlyAttendancePreview from './pages/MonthlyAttendance/MonthlyAttendancePreview/MonthlyAttendancePreview';
import ServiceMaster from './pages/RoleServiceMap/AddServiceMaster/ServiceMaster';
import EditSerivce from './pages/RoleServiceMap/EditService/EditService';
import AddRole from './pages/RoleServiceMap/AddRole/AddRole';
import CreateRole from './pages/RoleServiceMap/CreateRole/CreateRole';
import RoleServiceMap from './pages/RoleServiceMap/RoleServiceMap/RoleServiceMap';
import SalaryStructureForDesignation from './pages/SalaryStructure/SalaryStructureForm/SalaryStructureForDesignation';
import EmployeePayrollReport from './pages/SalaryStructure/EmployeeSalaryPayroll/EmployeePayrollReport';
import EmployeePayrollProcess from './pages/SalaryStructure/EmployeePayrollProcess/EmployeePayrollProcess';
import EmployeePayslip from './pages/SalaryStructure/Payslips/EmployeePayslip';
import EmployeePayrollsProcess from './pages/SalaryStructure/EmployeePayrollsProcess/EmployeePayrollsProcess';
import MonthlySalaryReport from './pages/SalaryStructure/MonthlySalaryReport/MonthlySalaryReport';
import PfRegistration from './pages/SalaryStructure/PfRegistration/PfRegistration';
import ESICMonthlyReport from './pages/SalaryStructure/ESICMonthlyReport/ESICMonthlyReport';
import EPFWages from './pages/SalaryStructure/EPFWages/EPFWages';
import ResignList from './pages/Resignation/ResignationFrom/ResignList';
import MonthlyBankStatement from './pages/SalaryStructure/BankStatement/MonthlyBankStatement';
import PaymentReceipt from './pages/SalaryStructure/Payment/PaymentReceipt';
import LeavesReport from './pages/HolidayManagementAndLeaves/LeaveReport/LeavesReport';
import EPFAndESICUpdate from './pages/SalaryStructure/EPFAndESICUpdate/EPFAndESICUpdate';
import EsiInsurance from './pages/SalaryStructure/Insurance/EsiInsurance';
import MonthlyWages from './pages/SalaryStructure/MonthlyWages/MonthlyWages';
import MonthlyEsicWage from './pages/SalaryStructure/MonthlyEsicWage/MonthlyEsicWage';
// import MyAttendance from './pages/DailyAttendace/MyAttendance/MyAttendance';
import FinalMonthlyReport from './pages/MonthlyAttendance/FinalMonthlyAttendance/FinalMonthlyReport';
import SalaryDisbursement from './pages/SalaryStructure/SalaryDisbursement/SalaryDisbursement';
import AnnexureEntry from './pages/MonthlyAttendance/Annexure/AnnexureEntry';
import AnnexureReport from './pages/MonthlyAttendance/AnnexureReport/AnnexureReport';
import LeaveApprovalList from './pages/HolidayManagementAndLeaves/LeaveApprovalList/LeaveApprovalList';
import PostingReport from './pages/Detiails/ProfilesForInterview/Posting/PostingReport';
import EmployeeEmailAndMobileNumberUpdate from './pages/EmployeesProfile/PendingProfiles/EmployeeCreation/EmployeeEmailPhUpdate/EmployeeEmailAndMobileNumberUpdate';
import ResignListEmployees from './pages/Resignation/ResignListEmployees/ResignListEmployees';
import EmployeeView from './pages/Detiails/ProfilesForInterview/View/EmployeeView';
import ExistingEmployee from './pages/EmployeesProfile/ExistingEmployee/ExistingEmployee';
import RejectedApplications from './pages/EmployeesProfile/ResubmitProfiles/ResubmitApplications';
import ResubmitApplications from './pages/EmployeesProfile/ResubmitProfiles/ResubmitApplications';
import DistrictAttendanceDashboard from './pages/Home/Dashboards/DistrictAttendanceDashboard/DistrictDashboard';
import DistrictAttendanceReport from './pages/Home/Dashboards/DistrictAttendanceReport/DistrictAttendanceReport';
import ZoneAttendanceDashboard from './pages/Home/Dashboards/ZoneAttendanceDashboard/ZoneDashboard';
import DistrictDashboard from './pages/Home/Dashboards/DistrictAttendanceDashboard/DistrictDashboard';
import ZoneDashboard from './pages/Home/Dashboards/ZoneAttendanceDashboard/ZoneDashboard';
import PMDashboard from './pages/Home/Dashboards/PMDashboard/PMDashboard';
import PatnaShqDashboard from './pages/Home/Dashboards/PatnaSHQDashboard/PatnaShqDashboard';
import ZoneWiseAttendanceReport from './pages/Home/Dashboards/ZoneReport/ZoneWiseAttendanceReport';
import PmAttendanceReport from './pages/Home/Dashboards/PMAttendanceReport/StateAttendanceReport';
import StateAttendanceReport from './pages/Home/Dashboards/PMAttendanceReport/StateAttendanceReport';
import UserSelfAttendance from './pages/DailyAttendace/UserSelfAttendance/MyAttendance';
import ShiftCreation from './pages/Shifts/ShiftCreation/ShiftCreation';
import ShiftAssigns from './pages/Shifts/ShiftAssign/ShiftAssigns';
import MyAttendancePreview from './pages/DailyAttendace/MyAttendance/MyAttendancePreview';
import MyAttendance from './pages/DailyAttendace/UserSelfAttendance/MyAttendance';
import CameraAndLocation from './pages/Testing/CamerAndLocation';
import DistrictWiseShifts from './pages/Shifts/DistrictWiseShifts/DistrictWiseShifts';
import ZonesAndDistrictWiseShifts from './pages/Shifts/ZonesAndDistrictWiseShifts/ZonesAndDistrictWiseShifts';
import ProtectedRoute from './pages/ProtectedPage/ProtectedRoute/ProtectedRoute';
import Unauthorized from './pages/ProtectedPage/UnauthorizedPage/Unauthorized';
import EmployeesData from './pages/Detiails/ProfilesForInterview/EmployeesData/EmployeesData';
import EmployeeAttendanceReport from './pages/MonthlyAttendance/EmployeeAtttendanceReport/EmployeeAttendanceReport';
import Promotion from './pages/EmployeePostingAndTransfer/EmployeePromotion/Promotion';
import EmployeeResignation from './pages/Resignation/EmployeeResignation/EmployeeResignation';
import RelevingEmployees from './pages/Resignation/RelevingEmployees/RelevingEmployees';
import AdminDashboard from './pages/Home/Dashboards/AdminDashboard/AdminDashboard';

import LatLongUpdate from './pages/Godowns/GodownLatLongUpdate/LatLongUpdate';
import LatLongCreation from './pages/Godowns/GodownLatLong/LatLongCreation';
import LocationReport from './pages/Godowns/LocationReport/LocationReport';
import UpdateBlockForGodown from './pages/Godowns/BlockUpdate/UpdateBlockForGodown';
import BlockCreationForGodown from './pages/Godowns/BlockCreation/BlockCreationForGodown';
import SubDivisionCreationForGodown from './pages/Godowns/SubDivisionCreation/SubDivisionCreationForGodown';
import SubDivisionUpdateForGodown from './pages/Godowns/SubDivisionUpdate/SubDivisionUpdateForGodown';



function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => localStorage.getItem('isLoggedIn') === 'true');

  useEffect(() => {
    const handleStorageChange = () => {
      setIsLoggedIn(localStorage.getItem('isLoggedIn') === 'true');
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const login = () => {
    localStorage.setItem('isLoggedIn', 'true');
    setIsLoggedIn(true);
  };

  const logout = () => {
    localStorage.setItem('isLoggedIn', 'false');
    setIsLoggedIn(false);
  };

  const rolesforPages = localStorage.getItem("role");

  return (
    <Router>
      <Routes>
        {/* Redirect root based on login */}
        <Route path="/" element={<Navigate to={isLoggedIn ? "/dashboard" : "/login"} replace />} />

        {/* ✅ Public routes (no header/footer) */}
        {!isLoggedIn && (
          <Route path="/" element={<Home logout={logout} />}>
            <Route path="login" element={<Login login={login} />} />
            <Route path="registrationnavbar" element={<RegistrationNavbar />} />
            <Route path="personaldetails" element={<PersonalDetails />} />
            <Route path="educationaldetails" element={<EducationDetails />} />
            <Route path='certifications' element={<Certifications />} />
            <Route path="experiencedetails" element={<ExperienceDetails />} />
            <Route path="addressdetails" element={<Addressdetails />} />
            <Route path="bankdetails" element={<Bankdetails />} />
            <Route path="idDetails" element={<IDDetails />} />
            <Route path="previewPage" element={<PreviewPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Route>
        )}

        {/* ✅ Protected routes (inside Home with header/footer) */}
        {isLoggedIn && (
          <Route path="/" element={<Home logout={logout} />}>
            <Route path="dashboard" element={<Dashboard logout={logout} />} />
            <Route path="register" element={<Registration />} />
            <Route path="changepassword" element={<ChangePassword />} />
            <Route path="resetpassword" element={<Resetpassword />} />
            <Route path="addService" element={<AddService />} />
            <Route path="createrole" element={<Createrole />} />
            <Route path="roleservice" element={<Roleservicemap />} />
            <Route path="userservice" element={<Userservicemap />} />

            <Route path="/dailyAttendance" element={<Attendence />} />
            <Route path="employeeOnboarding" element={<EmployeeOnboarding />} />
            <Route path="holidayManagement" element={<HolidayManagement />} />
            <Route path="employeeSalaryStructure" element={<SalaryStructure />} />
            {/* <Route path="pfdetails" element={<PFdetails />} /> */}
            <Route path="/registedEmployee" element={<RegistedEmployees />} />

            <Route path="onboardingEmployessList" element={<OnboardingEmployeesList />} />
            <Route path="onboardingEmployeeDetails" element={<OnboardingEmployeeDetails />} />
            <Route path='employeeTransfer' element={<EmployeeTransfer />} />
            <Route path="esicForm" element={<ESICForm />} />
            <Route path='epfForm' element={<EPFForm />} />
            <Route path="/leaveRequest" element={<LeaveRequest />} />
            <Route path="/leaveApproval" element={<AdminLeaveTable />} />
            <Route path="registeredemployees" element={<EmployeesRegistered />} />
            <Route path="/daliyAttendanceReport" element={<EmployeesAttendance />} />
            <Route path="salaryreport" element={<SalaryReport />} />
            <Route path="requirementManPowerForInterview" element={<RequirementManPowerForInterview />} />
            <Route path="portalOrAgency" element={<PortalOrAgencyForInterview />} />
            <Route path="shortList" element={<ShortListedByshortlistTeam />} />
            <Route path="interview" element={<InterviewForInterview />} />
            <Route path="feedBack" element={<Feedbackform />} />
            <Route path="hrRound" element={<HrRoundForInterview />} />
            <Route path="profilesforinterview" element={<ProfilesForInterview />} />
            <Route path="detailsofaddress" element={<DetailsofAddress />} />
            <Route path="testing" element={<Testing />} />
            <Route path="reportofinterview" element={<ReportsOfInterview />} />
            <Route path="/myProfile" element={<Profile />} />
            <Route path="resign" element={<Resignform />} />
            <Route path='/resignEmoloyees' element={<ListofResign />} />
            <Route path='profileinfo' element={<Profileinfo />} />

            <Route path='checkList' element={<CheckList />} />
            <Route path='employeeRejectedList' element={<ManagerCheckListReject />} />

            <Route path="*" element={<Navigate to="/dashboard" replace />} />

            <Route path="employeeCreationForm" element={<EmployeeCreationForm />} />
            <Route path="employeeApplications" element={<EmployeeApplications />}>
              <Route path="draft" element={<DraftApplications />} />
              <Route path="submitted" element={<SubmittedApplications />} />
              <Route path="resubmitApplications" element={<ResubmitApplications />} /> {/* Fixed typo */}
              <Route path="onBoardingPending" element={<OnboardingPending />} />
            </Route>
            {/* Forms now inside main app after login */}
            <Route path="registrationnavbar" element={<RegistrationNavbar />} />
            <Route path="personaldetails" element={<PersonalDetails />} />
            <Route path="educationaldetails" element={<EducationDetails />} />
            <Route path='certifications' element={<Certifications />} />
            <Route path="experiencedetails" element={<ExperienceDetails />} />
            <Route path="addressdetails" element={<Addressdetails />} />
            <Route path="bankdetails" element={<Bankdetails />} />
            <Route path="idDetails" element={<IDDetails />} />
            <Route path="previewPage" element={<PreviewPage />} />
            <Route path="employeeCheckListVerification" element={<ManagerCheckList />} />
            <Route path="managerCheckListView" element={<ManagerCheckListView />} />
            <Route path="employeeJoiningForm" element={<EmployeeJoiningForm />} />
            <Route path="employeePosting" element={<EmployeePosting />} />
            <Route path="monthlyAttendance" element={<MonthlyAttendance />} />
            <Route path="/monthlyAttendanceReport" element={<MonthlyAttendanceReport />} />
            <Route path="monthlyAttendanceVerification" element={<MonthlyAttendanceVerification />} />
            <Route path='monthlyAttendancePreview' element={<MonthlyAttendancePreview />} />
            <Route path="/serviceMaster" element={<ServiceMaster />} />
            <Route path="editService/:id" element={<EditSerivce />} />
            <Route path="/createRole" element={<CreateRole />} />
            <Route path="/roles/edit/:roleId" element={<CreateRole />} />
            <Route path="addRole" element={<ProtectedRoute requiredRoles={["ADMIN"]}><AddRole /></ProtectedRoute>} />
            <Route path="roleServiceMap" element={<ProtectedRoute requiredRoles={["ADMIN"]}><RoleServiceMap /></ProtectedRoute>} />
            <Route path="salaryStructureForDesignation" element={<SalaryStructureForDesignation />} />
            <Route path="employeePayrollReport" element={<EmployeePayrollReport />} />
            <Route path="employeePayrollProcess" element={<EmployeePayrollProcess />} />
            <Route path="employeePayslipGeneration" element={<EmployeePayslip />} />
            <Route path="monthlySalaryReport" element={<MonthlySalaryReport />} />
            <Route path="pfRegistration" element={<PfRegistration />} />
            <Route path='/esicMonthlyReport' element={<ESICMonthlyReport />} />
            <Route path='/ePFWages' element={<EPFWages />} />
            <Route path="/resignForm" element={<ResignList />} />
            <Route path="/monthlyBankStatement" element={<MonthlyBankStatement />} />
            <Route path="/paymentReceipt" element={<PaymentReceipt />} />
            <Route path="leavesReport" element={<LeavesReport />} />
            <Route path="/epfAndEsicUpdation" element={<EPFAndESICUpdate />} />
            <Route path="/esiInsurance" element={<EsiInsurance />} />
            <Route path="/monthlyWages" element={<MonthlyWages />} />
            <Route path="/monthlyEsicWage" element={<MonthlyEsicWage />} />
            <Route path="/MyAttendancePreview" element={<MyAttendancePreview />} />
            <Route path="/myAttendance" element={<MyAttendance />} />
            <Route path="/finalMonthlyReport" element={<FinalMonthlyReport />} />
            <Route path="/salaryDisbursement" element={<SalaryDisbursement />} />
            <Route path='/annexureEntry' element={<AnnexureEntry />} />
            <Route path='/annexureReport' element={<AnnexureReport />} />

            {/* <Route path="/employeesPayslipGeneration" element={<EmployeePayrollsProcess />} /> */}

            <Route path="/leaveApprovalList" element={<LeaveApprovalList />} />
            <Route path="/postingReport" element={<PostingReport />} />
            <Route path='/emailMobileUpdation' element={<EmployeeEmailAndMobileNumberUpdate />} />
            {/* <Route path='employeeEmialAndMonileNumUpdate' element={<EmployeeEmailAndMobileNumberUpdate/>}/> */}
            <Route path='ResignListEmployees' element={<ResignListEmployees />} />
            <Route path="/employeeview/:id" element={<EmployeeView />} />
            <Route path="/existingEmployee" element={<ExistingEmployee />} />
           <Route path="districtDashboard" element={<ProtectedRoute requiredRoles={["ITM","ADMIN"]}><DistrictDashboard /></ProtectedRoute>} />
            <Route path="districtAttendanceReport" element={<ProtectedRoute requiredRoles={["ITM","ADMIN"]}><DistrictAttendanceReport /></ProtectedRoute>} />
            <Route path="zoneDashboard" element={<ProtectedRoute requiredRoles={["APM_Zone","ADMIN"]}><ZoneDashboard /></ProtectedRoute>} />
            <Route path="pmDashboard" element={<ProtectedRoute requiredRoles={["PM","APM_OPERATIONS","ADMIN"]}><PMDashboard /></ProtectedRoute>} />
            <Route path="patnaSHQDashboard" element={<ProtectedRoute requiredRoles={["APM_OPERATIONS","ADMIN"]}><PatnaShqDashboard /></ProtectedRoute>} />
            <Route path='zoneWiseAttendanceReport' element={<ProtectedRoute requiredRoles={["APM_Zone","ADMIN"]}><ZoneWiseAttendanceReport /></ProtectedRoute>} />
            <Route path="stateAttendanceReport" element={<StateAttendanceReport />} />
            {/* <Route path="userSelfAttendance" element={<UserSelfAttendance />} /> */}
             <Route path="myAttendance" element={<MyAttendance />} />
            <Route path='shiftCreation' element={<ShiftCreation />} />
            <Route path="shiftAssigns" element={<ProtectedRoute requiredRoles={["ADMIN","APM_Zone","APM_OPERATIONS"]}><ShiftAssigns /></ProtectedRoute>} />
            <Route path='cameraAndLocation' element={<CameraAndLocation />} />
            <Route path='districtWiseShifts' element={<ProtectedRoute requiredRoles={["APM_Zone","ADMIN"]}><DistrictWiseShifts /></ProtectedRoute>} />
            <Route path='zonesAndDistrictWiseShifts' element={<ProtectedRoute requiredRoles={["APM_OPERATIONS","ADMIN"]}><ZonesAndDistrictWiseShifts /></ProtectedRoute>} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/employeesDetails" element={<EmployeesData />} />
            <Route path="/employeeAttendanceReport" element={<EmployeeAttendanceReport/>}/>
            <Route path="/promotion" element={<Promotion/>} />
            <Route path='/employeeResignation' element={<EmployeeResignation/>}/>
            <Route path="/relevingEmployees" element={<RelevingEmployees/>}/>
            <Route path="/adminDashboard" element={<AdminDashboard/>}/>
            <Route path= "/latLongCreation" element={<LatLongCreation/>}/>
            <Route path= "/latLongUpdate" element={<LatLongUpdate/>}/>
            <Route path= "/locationReport" element={<LocationReport/>}/>
            <Route path="/updateBlock" element={<UpdateBlockForGodown/>}/>
            <Route path="/createBlock" element={<BlockCreationForGodown/>}/>
            <Route path='/createSubDivision' element={<SubDivisionCreationForGodown/>}/>
            <Route path='/updateSubDivision' element={<SubDivisionUpdateForGodown/>}/>

          </Route>
        )}
      </Routes>
    </Router>
  );

}

export default App;
